<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  created() {
    ap.hideOptionButton();
  }
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
  padding: 0;
  margin: 0;
}
body,
html {
  background-color: #f4f4f4;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.rb{
  border: solid 1px red;
}
/* page{
  background-color: #f4f4f4;
} */

page{
    background:rgba(247,247,247,1);
}

view {
  box-sizing: border-box;
}
.cell{
  width:94.667vw;
  height:50px;
  background:rgba(255,255,255,1);
  padding-left: 4.533vw;
  padding-right: 4.533vw;
  /* display: flex;
  align-items: center; */
	display: flex;
	justify-content: space-between;
}
.cell-title{
  display: inline-block;
  color: #666666;
  font-size: 14px;
  line-height: 50px;
  width: auto;
}
.cell-up{
  border-radius:6px 6px 0px 0px;
  margin-top: 10px;

}
.cell-down{
  border-radius:0px 0px 6px 6px;

}
.cell-content{
	display:inline-block;
  line-height: 50px;
  font-size: 14px;
  /* flex: 1;
  text-align: right; */
}
.price-in-cell{
  float: right;
  line-height: 50px;
}
.price{
  color: #FF9711;
  display: inline-block;
}
.button-container{
  width: 100vw;
  height: 60px;
  position: fixed;
  bottom: 0;
  background:rgba(255,255,255,1);
  box-shadow:0px 0px 16px 0px rgba(211,211,211,0.5);
}

.point{
  width: 7px;
  height: 12px;
}
</style>
